import { gateway } from "../../../gateway";

export const deleteMerchantInfo = async (): Promise<void> => {
  try {
    await gateway.delete("/paypal/e-commerce/account");
  } catch (error: any) {
    console.error("Error deleting merchant info:", error);
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to delete merchant info";
    throw new Error(errorMessage);
  }
};
